/** KPIs da aplicação */
export interface KPI {
    id: number;
    sigla: string;
    nome: string;
}

export const KPI_RAP: KPI = {
    id: 1,
    sigla: 'RAP',
    nome: 'Receita Anual Pretendida',
};

export const KPI_RMP: KPI = {
    id: 2,
    sigla: 'RMP',
    nome: 'Receita Mensal Pretendida',
};

export const KPI_RTP: KPI = {
    id: 3,
    sigla: 'RTP',
    nome: 'Receita Trimestral Pretendida',
};

export const KPI_RSP: KPI = {
    id: 4,
    sigla: 'RSP',
    nome: 'Receita Semestral Pretendida',
};

export const KPI_RAR: KPI = {
    id: 5,
    sigla: 'RAR',
    nome: 'Receita Anual Realizada',
};

export const KPI_CUSTOMER_SHARE: KPI = {
    id: 6,
    sigla: 'CS',
    nome: 'Customer Share',
};

/** KPI de Up Sell */
export const KPI_UP_SELL: KPI = {
    id: 7,
    sigla: 'UPS',
    nome: 'Up Sell',
};

/** KPI de Up Sell Mensal */
export const KPI_UPSELL_MENSAL: KPI = {
    id: 8,
    sigla: 'USM',
    nome: 'Up Sell Mensal',
};

/** KPI de Up Sell Anual */
export const KPI_UPSELL_ANUAL: KPI = {
    id: 9,
    sigla: 'USA',
    nome: 'Up Sell Anual',
};

/** KPI de Cross Sell */
export const KPI_CROSS_SELL: KPI = {
    id: 10,
    sigla: 'CRS',
    nome: 'Cross Sell',
};

/** KPI de Cross Sell e Up Sell */
export const KPI_CROSS_SELL_UP_SELL: KPI = {
    id: 11,
    sigla: 'CUS',
    nome: 'Cross Sell e Up Sell',
};

/** KPI de Sell In de Cliente */
export const KPI_SELL_IN_CLIENTE: KPI = {
    id: 12,
    sigla: 'SIC',
    nome: 'Sell In Cliente',
}

export const KPIs: KPI[] = [
    KPI_RAP,
    KPI_RMP,
    KPI_RTP,
    KPI_RSP,
    KPI_RAR,
    KPI_CUSTOMER_SHARE
];
